import { useRef, useState } from "react";
import { Button, ButtonToolbar, Checkbox, CheckboxGroup, Form, Schema } from "rsuite"
import { registerUser } from "../../queries/apiQueries";
import { Loader } from 'rsuite';

const defaultFormValue = {
    username: '',
    modules: [],
    emailId: '',
    // rolename: '',
    // contactNumber: '',
    organization: '',
    // genAIModules: []
};

const UserForm = () => {
    const { StringType, NumberType, ArrayType } = Schema.Types;

    const [formSubmitted, setFormSubmitted] = useState(false);

    const model = Schema.Model({
        username: StringType().isRequired("Name is required"),
        emailId: StringType().isEmail("Invalid email").isRequired("Email Id is required"),
        // contactNumber: NumberType("Only numbers are allowed"),
        organization: StringType(),
        // rolename: StringType(),
        modules: ArrayType().isRequired("Please select at least one module"),
        // genAIModules: ArrayType()
    });

    const [formError, setFormError] = useState({});
    const formRef = useRef<any>();

    const [userDetails, setUserDetails] = useState(defaultFormValue);

    const [loading, setLoading] = useState(false);

    const submitForm = () => {
        setLoading(true);
        if (!formRef.current.check()) {
            console.error('Form Error', formError);
            setLoading(false);
            return;
        } else {
            let payload: any = JSON.parse(JSON.stringify(userDetails));
            payload.modules = JSON.stringify([...payload.modules/* , ...payload.genAIModules */]);
            /* if (payload.contactNumber.length > 0) {
                payload.contactNumber = "+1" + payload.contactNumber;
            } */
            payload.contactNumber = null;
            registerUser(payload).then((res: any) => {
                if (res.data.success) {
                    setFormSubmitted(true);
                    // setUserDetails(defaultFormValue)
                }
                setLoading(false);
            }).catch((err: any) => {
                console.log(err);
                setLoading(false);
            })
        }
    }

    return (
        loading ? <Loader backdrop content="Loading..." size="md" vertical /> : <div className="flex p-[5vh] justify-between items-center">
            {formSubmitted ? <div className="justify-center items-center flex h-full w-full font-semibold text-[14px] sm:text-[14px] md:text-[16px] lg:text-[2vh]">Thank you for your interest. We'll get back to you shortly.</div> : <>
                <div></div>
                <div className="flex flex-col gap-5 grow-1">
                    <Form ref={formRef} onChange={(userDetails: any) => setUserDetails(userDetails)} formValue={userDetails} model={model} onCheck={setFormError} className="flex flex-col" >
                        <Form.Group ref={formRef} controlId="username">
                            <Form.ControlLabel><sup className="text-red-500">*</sup>Full Name</Form.ControlLabel>
                            <Form.Control className="sm:!w-[500px] md:!w-[500px] lg:!w-[25vw]" name="username" />
                        </Form.Group>
                        <Form.Group ref={formRef} controlId="emailId">
                            <Form.ControlLabel><sup className="text-red-500">*</sup>Email</Form.ControlLabel>
                            <Form.Control className="sm:!w-[500px] md:!w-[500px] lg:!w-[25vw]" name="emailId" type="email" />
                        </Form.Group>
                        <Form.Group ref={formRef} controlId="organization">
                            <Form.ControlLabel>Organization</Form.ControlLabel>
                            <Form.Control className="sm:!w-[500px] md:!w-[500px] lg:!w-[25vw]" name="organization" />
                        </Form.Group>
                        {/* <Form.Group ref={formRef} controlId="rolename">
                            <Form.ControlLabel>Role in the Organization</Form.ControlLabel>
                            <Form.Control className="sm:!w-[500px] md:!w-[500px] lg:!w-[25vw]" name="rolename" />
                        </Form.Group> */}
                        {/* <Form.Group ref={formRef} controlId="contactNumber">
                            <Form.ControlLabel>Contact Number</Form.ControlLabel>
                            <div className="flex gap-[5px]">
                                <Form.Control className="!w-[50px] sm:!w-[50px] md:!w-[50px] lg:!w-[4vw]" disabled readOnly={true} value={"+1"} name="countrycode" />
                                <Form.Control className="!w-[245px] sm:!w-[445px] md:!w-[445px] lg:!w-[21vw]" name="contactNumber" />
                            </div>
                        </Form.Group> */}
                        <Form.Group ref={formRef} controlId="modules">
                            <Form.ControlLabel><sup className="text-red-500">*</sup>List of WDEdge modules interested in:</Form.ControlLabel>
                            <Form.Control name="modules" accepter={CheckboxGroup} className="flex flex-col flex-wrap max-h-[15vh] gap-x-[6vh] sm:max-h-[80px] md:max-h-[80px] lg:max-h-[15vh] sm:gap-x-[10px] md:gap-x-[12px] lg:gap-x-[6vh]">
                                <Checkbox value="demandBrain">DemandSync</Checkbox>
                                <Checkbox value="marginBrain">MarginBrain</Checkbox>
                                <Checkbox value="catman">CategoryIQ</Checkbox>
                                <Checkbox value="rebatesOptimizer">Rebates Optimizer</Checkbox>
                                <Checkbox value="opsBrain">OpsBrain</Checkbox>
                            </Form.Control>
                        </Form.Group>

                        {/* <Form.Group ref={formRef} controlId="genAIModules">
                            <Form.ControlLabel>List of GenAI modules interested in:</Form.ControlLabel>
                            <Form.Control className="flex flex-col flex-wrap gap-x-[6vh]" name="genAIModules" accepter={CheckboxGroup} >
                                <Checkbox value="salesPlanningAssistant">Sales Planning Assistant</Checkbox>
                                <Checkbox value="customerServiceAssistant">Customer Service Assistant</Checkbox>
                                <Checkbox value="enterpriseSearch">Enterprise Search</Checkbox>
                                <Checkbox value="productSearch">Product Search</Checkbox>
                            </Form.Control>
                        </Form.Group> */}
                        <Form.Group>
                            <ButtonToolbar className="justify-center">
                                <Button appearance="primary" onClick={submitForm}>Submit</Button>
                            </ButtonToolbar>
                        </Form.Group>
                    </Form>
                </div>
                <div></div>
            </>}
        </div>)
}

export default UserForm;